import {
    List,
    ListItem,
    ListItemText,
    Typography,
    Box,
    Chip,
    useTheme
} from '@mui/material';
import React from "react";
import { useNavigate } from 'react-router-dom';
import DataNotFound from '../DataNotFound/DataNotFound';
import DataLoader from '../DataLoader/DataLoader';

interface Notification {
    id: string;
    subject: string;
    message: string;
    date_created: string;
    is_read: boolean;
    view_link?: string;
}

interface SystemTabProps {
    notificationData?: any;
    loading: boolean;
    handleDrawerToggle: () => void;
    formatDate: (date: string) => string;
}

const SystemTab: React.FC<SystemTabProps> = ({ notificationData, loading, handleDrawerToggle, formatDate }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const mode = theme.palette.mode == "light" ? "light" : "dark"

    return (
        <Box
            sx={{
                // height: "72vh",
                // overflowY: "auto",
                // "&::-webkit-scrollbar": { width: "8px" },
                // "&::-webkit-scrollbar-track": { background: "#f1f1f1" },
                // "&::-webkit-scrollbar-thumb": { background: "#888", borderRadius: "50px" },
                // "&::-webkit-scrollbar-thumb:hover": { background: "#555" },
            }}
        >
            {loading ? (
                <Box sx={{ height: "450px", width: "100%" }}>
                    <DataLoader />
                </Box>
            ) : (
                <List className='notification-list'>
                    {notificationData?.[0]?.is_read && (
                        <Typography
                            sx={{
                                color: theme.palette.mode === "light" ? "#000" : "#fff",
                                fontSize: 17,
                                fontWeight: 600,
                                backgroundColor: theme.palette.mode === "light" ? "#fff" : "#3f3f3f",
                                marginLeft: "15px",
                            }}
                        >
                            {notificationData?.[0]?.is_read ? "Older Notifications" : ""}
                        </Typography>
                    )}

                    {notificationData?.length > 0 ? (
                        notificationData.map((notification:any) => (
                            <Box
                                key={notification.id}
                                onClick={() => {
                                    if (notification.view_link) {
                                        if(`/admin${notification.view_link}`===window.location.pathname){
                                            window?.location?.reload();
                                            handleDrawerToggle();
                                        }else{
                                        navigate(`/admin${notification.view_link}`);
                                        handleDrawerToggle();
                                        }
                                    }
                                }}
                                sx={{
                                    cursor: notification.view_link ? "pointer" : "default",
                                    "&:hover": notification.view_link ? { background: theme.palette.mode === "light" ? "#eee" : "#555"} : {},
                                    "&:first-of-type": { mt: "2px" }
                                }}
                            >
                                <ListItem sx={{ borderBottom: "1px solid #eee" }}>
                                    <ListItemText
                                        primary={
                                            <Typography variant="h6" sx={{ fontSize: "14px", fontWeight: 700 }}>
                                                {notification.subject || "NA"}
                                            </Typography>
                                        }
                                        secondary={
                                            <>
                                                <Typography
                                                    variant="body2"
                                                    color="text.primary"
                                                    sx={{ fontSize: "13px", fontWeight: 400 }}
                                                >
                                                    {notification.message || "NA"}
                                                </Typography>
                                                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                                                    <Chip
                                                        variant="filled"
                                                        label={formatDate(notification.date_created || "NA")}
                                                        sx={{
                                                            marginTop: "5px",
                                                            borderRadius: "4px",
                                                            width: "90px",
                                                            height: "18px",
                                                            fontSize: "10px",
                                                            fontWeight: 400,
                                                        }}
                                                    />
                                                </Box>
                                            </>
                                        }
                                        disableTypography
                                    />
                                </ListItem>
                            </Box>
                        ))
                    ) : (
                        <Box className="notification-datanotfound">
                            <DataNotFound mode={mode}/>
                        </Box>
                    )}
                </List>
            )}
        </Box>
    );
};

export default SystemTab;
